import React, { useState, useEffect } from "react";
import { Modal, FloatingLabel, Form } from "react-bootstrap";
import LoadingButton from "./LoadingButton.js";
import { useGlobalContext } from "./GlobalContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Timestamp } from "firebase/firestore";

function ModalEvent({
  show,
  currentEventEdit,
  onHide,
  onValid,
  onCancel,
}) {
  const {
    db,
    user,
    handleShowConfirmation,
    handleCloseConfirmation,
    getPhotoEvent,
    resizeImage,
    getDateStrFromTimestamp
  } = useGlobalContext();
  const [title, setTitle] = useState(
    currentEventEdit ? currentEventEdit.title : ""
  );
  const [description, setDescription] = useState(
    currentEventEdit ? currentEventEdit.description : ""
  );
  const [photoUrl, setPhotoUrl] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [heureDebut, setHeureDebut] = useState("");
  const [heureFin, setHeureFin] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      if (currentEventEdit) {
        setTitle(currentEventEdit.title || "");
        setDescription(currentEventEdit.description || "");
        setDateDebut(currentEventEdit.dateDebut !== "" ? getDateStrFromTimestamp(currentEventEdit.dateDebut) : "");
        setDateFin(currentEventEdit.dateFin !== "" ? getDateStrFromTimestamp(currentEventEdit.dateFin) : "");
        setHeureDebut(currentEventEdit.heureDebut || "");
        setHeureFin(currentEventEdit.heureFin || "");
        setPhoto(null);
        setPhotoUrl(currentEventEdit.photoUrl || null);
        setVisible(currentEventEdit.visible || false);
      } else {
        setTitle("");
        setDescription("");
        setDateDebut("");
        setDateFin("");
        setHeureDebut("");
        setHeureFin("");
        setPhoto(null);
        setPhotoUrl(null);
        setVisible(false);
      }
    }
  }, [currentEventEdit, show, getDateStrFromTimestamp]);

  const handleAddEvent = async () => {
    try {
      const uid = "auto-generated" + Date.now();
      if (photo) {
        const resizedImageBlob = await resizeImage(photo, 1500); // Ajustez la taille souhaitée
        await db
          .addPhotoUrlEvent(uid, resizedImageBlob)
          .then(async (photoUrl) => {
            await db.addEvent({
              uid: uid,
              title,
              description,
              photoUrl: photoUrl,
              dateDebut: dateDebut === "" ? "" : Timestamp.fromDate(new Date(dateDebut)),
              dateFin: dateFin === "" ? "" : Timestamp.fromDate(new Date(dateFin)),
              heureDebut,
              heureFin,
              visible
            });
          })
          .catch((error) => {
            console.error("Upload impossible : ", error);
          });
      } else {
        await db.addEvent({
          uid: uid,
          title,
          description,
          photoUrl: null,
          dateDebut: dateDebut === "" ? "" : Timestamp.fromDate(new Date(dateDebut)),
          dateFin: dateFin === "" ? "" : Timestamp.fromDate(new Date(dateFin)),
          heureDebut,
          heureFin,
          visible
        });
      }

      onValid();
    } catch (error) {
      console.log("Error add event", error);
    }
  };

  const handleUpdateEvent = async () => {
    try {
      if (currentEventEdit.photoUrl === null && photo !== null) {
        await db.addPhotoUrlEvent(currentEventEdit.uid, photo)
          .then(async (photoUrl) => {
            const obj = {
              title,
              description,
              dateDebut: dateDebut === "" ? "" : Timestamp.fromDate(new Date(dateDebut)),
              dateFin: dateFin === "" ? "" : Timestamp.fromDate(new Date(dateFin)),
              heureDebut,
              heureFin,
              photoUrl,
              visible
            }
            await db.updateEvent(currentEventEdit.uid, obj);
          })
      } else {
        const obj = {
          title,
          description,
          dateDebut: dateDebut === "" ? "" : Timestamp.fromDate(new Date(dateDebut)),
          dateFin: dateFin === "" ? "" : Timestamp.fromDate(new Date(dateFin)),
          heureDebut,
          heureFin,
          visible
        }
        await db.updateEvent(currentEventEdit.uid, obj);
      }
      onValid();
    } catch (error) {
      console.log("Error edit event", error);
    }
  };

  const handleRemoveEvent = async () => {
    try {
      if (currentEventEdit.photoUrl) {
        db.deletePhotoUrlEvent(currentEventEdit).then(async () => {
          await db.removeEvent(currentEventEdit.uid);
          currentEventEdit.photoUrl = null;
        });
      } else {
        await db.removeEvent(currentEventEdit.uid);
      }
    } catch (error) {
      console.log("Error Remove document", error);
    }
    onValid();
    handleCloseConfirmation();
  };

  const handleImageDelete = async () => {
    db.deletePhotoUrlEvent(currentEventEdit)
      .then(async () => {
        currentEventEdit.photoUrl = null;
        setPhotoUrl(null);
        handleCloseConfirmation();
      });
  };

  const handleImageChange = async (e) => {
    const photo = e.target.files[0];
    if (photo == null) return;
    try {
      setPhoto(photo);
    } catch (error) {
      console.log("Error DocumentChange", error);
    }
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {currentEventEdit
            ? "Modification d'un évènement"
            : "Ajout d'un évènement"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Form.Check
            type="checkbox"
            id="visibleId"
            label="Visible"
            checked={visible}
            onChange={(e) => {
              setVisible(e.target.checked);
            }}
          />
          <FloatingLabel
            label="Titre"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Form.Control
              type="text"
              style={{ width: "100%" }}
              autoComplete="on"
              value={title}
              required
              onChange={(e) => setTitle(e.target.value)}
              placeholder=""
            />
          </FloatingLabel>
          <div style={{ display: "flex", width: "100%" }}>
            <FloatingLabel
              label="Date de début"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Form.Control
                type="date"
                style={{ width: "100%" }}
                value={dateDebut}
                required
                onChange={(e) => {
                  setDateDebut(e.target.value);
                  if (dateFin === "")
                    setDateFin(e.target.value);
                }}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Heure de début"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Form.Control
                type="time"
                style={{ width: "100%" }}
                value={heureDebut}
                required
                onChange={(e) => {
                  setHeureDebut(e.target.value);
                  if (heureFin === "")
                    setHeureFin(e.target.value);
                }}
              />
            </FloatingLabel>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <FloatingLabel
              label="Date de fin"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Form.Control
                type="date"
                style={{ width: "100%" }}
                value={dateFin}
                required
                onChange={(e) => setDateFin(e.target.value)}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Heure de fin"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Form.Control
                type="time"
                style={{ width: "100%" }}
                value={heureFin}
                required
                onChange={(e) => setHeureFin(e.target.value)}
              />
            </FloatingLabel>
          </div>
          <div style={{ display: "flex", width: "100%", marginBottom: "20px", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {photoUrl === null ?
              <>
                <Form.Group controlId="formFile">
                  <Form.Label className="btn btn-custom1">
                    Sélectionner
                  </Form.Label>
                  <Form.Control
                    style={{ display: "none" }}
                    type="file"
                    onChange={handleImageChange}
                  />
                </Form.Group>

              </> :
              <LoadingButton
                className="btn btn-custom1"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                onClickPromise={async () => {
                  handleShowConfirmation(
                    "Voulez-vous enlever l'image ? ",
                    "Le reste des informations seront conservés",
                    "danger",
                    "Enlever",
                    "Annuler",
                    null,
                    handleImageDelete
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{
                    fontSize: "1em",
                    marginRight: "5px",
                    color: "red",
                  }}
                />
                Supprimer l'image
              </LoadingButton>
            }
            {photoUrl !== null ?
              getPhotoEvent(photoUrl, title, {
                maxHeight: "150px",
                maxWidth: "150px",
                height: "100%",
                width: "100%",
                borderRadius: "5px",
              })
              : photo !== null ?
                <span style={{ textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>{photo.name}</span>
                :
                <span style={{ textAlign: "center", marginRight: "5px", marginBottom: "5px", marginLeft: "5px" }}>Aucune image</span>
            }
          </div>

          <div
            style={{ display: "flex", width: "100%", alignItems: "center", marginBottom: "5px" }}
          >
            <FloatingLabel controlId="floatingTextarea2" label="Description" style={{ flex: "1 1 auto" }}>
              <Form.Control
                className="mb-3"
                as="textarea"
                placeholder="Description"
                style={{ height: "150px" }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </FloatingLabel>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {currentEventEdit ? (
              <LoadingButton
                className="btn btn-custom5"
                disabled={user && currentEventEdit && user.uid === currentEventEdit.uid}
                onClick={() => {
                  handleShowConfirmation(
                    "Supprimer cet évènement ?",
                    "",
                    "danger",
                    "Supprimer",
                    "Annuler",
                    handleRemoveEvent
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ fontSize: "1em", marginRight: "5px", color: "red" }}
                />
                Supprimer
              </LoadingButton>
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <LoadingButton className="btn btn-custom1" onClick={onCancel}>
              Annuler
            </LoadingButton>
            <LoadingButton
              className="btn btn-custom2"
              onClickPromise={
                currentEventEdit ? handleUpdateEvent : handleAddEvent
              }
            >
              {currentEventEdit ? "Enregistrer" : "Ajouter"}
            </LoadingButton>
          </div>
        </div>
      </Modal.Footer>
    </Modal >
  );
}

export default ModalEvent;
